import { isPlatformNodeJS } from './platform.is-node.js';

const canvas = isPlatformNodeJS() ? void 0 : typeof OffscreenCanvas !== "undefined" ? new OffscreenCanvas(2e3, 1e3) : document.createElement("canvas");
function determineTextWidth(text, args) {
  if (!canvas) {
    return 0;
  }
  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("worker.determineLetterSpacing(): Failed to load context");
  }
  const devicePixelRatio = isPlatformNodeJS() ? 1 : window.devicePixelRatio;
  context.font = `${args.weight} ${args.size * devicePixelRatio}px ${args.family}`;
  context.textBaseline = "top";
  context.textAlign = "left";
  const lines = text.split("\n");
  const widestLine = Math.max(
    ...lines.map((line) => context.measureText(line).width)
  );
  return widestLine / devicePixelRatio;
}

export { determineTextWidth };
//# sourceMappingURL=dom.determine-text-width.js.map
